import React, { useEffect, useState } from 'react'
import { AppBar, Button, Container, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { cloneDeep, isEqual } from 'lodash'

import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import AvailableMemberships from '../../../components/Cards/Facility/AvailableMemberships'
import {
	getFacilityAdvancedSettings,
	updateFacilityAdvancedSettings
} from '../../../actions/facilities/facilities.actions'

const useStyles = makeStyles(() => ({
	root: {
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	}
}))

const FacilityMemberships = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)
	const loading = useSelector((state) => state.specific.facilities.loading)

	const [settings, setSettings] = useState(null)
	const [baseline, setBaseline] = useState(null)
	const [migrated, setMigrated] = useState(true)
	const [isSaveShown, setIsSaveShown] = useState(false)

	const loadSettings = () => {
		if (!params.facilityId) return

		dispatch(getFacilityAdvancedSettings(params.facilityId)).then((payload) => {
			if (!payload) return

			const next = {
				facility_updated_at: payload.updatedAt,
				available_membership_types: cloneDeep(payload.available_membership_types || [])
			}
			setSettings(next)
			setBaseline(cloneDeep(next))
			// Memberships are facility-scoped via facility_id; launch is a separate backfill.
			setMigrated((payload.available_membership_types || []).length > 0)
			setIsSaveShown(false)
		})
	}

	useEffect(() => {
		loadSettings()
	}, [params.facilityId])

	useEffect(() => {
		if (settings && baseline) {
			setIsSaveShown(!isEqual(settings, baseline))
		}
	}, [settings, baseline])

	const updateMembership = (id, key, val) => {
		setSettings({
			...settings,
			available_membership_types: (settings.available_membership_types || []).map((membership) =>
				membership._id === id ? { ...membership, [key]: val } : membership
			)
		})
	}

	const updateTrialMembership = (id, key, val) => {
		setSettings({
			...settings,
			available_membership_types: (settings.available_membership_types || []).map((membership) =>
				membership._id === id
					? {
							...membership,
							trial_settings: {
								...(membership.trial_settings || {}),
								[key]: val
							}
					  }
					: membership
			)
		})
	}

	const saveChanges = () => {
		dispatch(
			updateFacilityAdvancedSettings(params.facilityId, {
				facility_updated_at: settings.facility_updated_at,
				available_membership_types: settings.available_membership_types
			})
		).then((payload) => {
			if (!payload) return

			const next = {
				facility_updated_at: payload.updatedAt,
				available_membership_types: cloneDeep(payload.available_membership_types || [])
			}
			setSettings(next)
			setBaseline(cloneDeep(next))
			setIsSaveShown(false)
		})
	}

	const clearChanges = () => {
		setSettings(cloneDeep(baseline))
		setIsSaveShown(false)
	}

	return (
		<div>
			{settings ? (
				<Container className={classes.root} maxWidth="auto">
					<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
						Memberships
						{selectedFacility?.name ? ` — ${selectedFacility.name}` : ''}
					</Typography>
					<AvailableMemberships
						memberships={settings.available_membership_types}
						updateMembership={updateMembership}
						updateTrialMembership={updateTrialMembership}
						migrated={migrated}
					/>

					{isSaveShown && migrated ? (
						<AppBar position="fixed" color="primary" className={classes.appBar}>
							<Toolbar>
								<Container maxWidth="md">
									<Button
										variant="contained"
										color="secondary"
										disabled={loading}
										style={{ marginRight: '8px' }}
										onClick={saveChanges}>
										Save Changes
									</Button>
									<Button variant="outlined" color="secondary" onClick={clearChanges}>
										Cancel
									</Button>
								</Container>
							</Toolbar>
						</AppBar>
					) : null}
				</Container>
			) : null}
			{loading ? <LoadingOverlay /> : null}
		</div>
	)
}

export default FacilityMemberships
